import React, {useEffect, useState} from "react";
import {useFetch} from "../../../hooks/useFetch";
import {useStore} from "../../../hooks/useStore";
import {Col, Row, Select, Table} from "antd";
import ActiveTransfersTable from "./activeTransfersTable/ActiveTransfersTable";

export const ActiveTransfers = () => {
    const [pageParam, setPageParam] = useState(1);
    const stores = useStore();
    const [fromCenter, setFromCenter] = useState(null);
    const [toCenter, setToCenter] = useState(null);
    const [fromCenterSearch, setFromCenterSearch] = useState("");
    const [toCenterSearch, setToCenterSearch] = useState("");

    const [activeTransfersLoading, activeTransfersData, _, __, refetchActiveTransfers] = useFetch({
        fetchFn: stores.transferStore.activeTransfers.bind(null, {
            page: pageParam,
            limit: 10,
            ...(fromCenter && {fromId: fromCenter}),
            ...(toCenter && {toId: toCenter})
        }),
        showLoading: true,
        dependencies: [pageParam, fromCenter, toCenter]
    });

    const [fromCentersLoading, fromCenters] = useFetch({
        fetchFn: stores.transferStore.transferCenters.bind(null, {}),
        showLoading: true
    });

    const [toCentersLoading, toCenters] = useFetch({
        fetchFn: stores.transferStore.transferCenters.bind(null, {}),
        showLoading: true
    });

    const handlePageChange = page => {
        setPageParam(page);
    };

    const handleFromCenterChange = value => {
        setFromCenter(value);
        setPageParam(1);
    };

    const handleToCenterChange = value => {
        setToCenter(value);
        setPageParam(1);
    };

    return (
        <>
            <h1>Aktif Transferler</h1>
            <Row style={{display: "flex", marginTop: "20px", marginBottom: "50px"}}>
                <div style={{display: "flex", gap: "20px", width: "50%"}}>
                    <Col span={6}>
                        <Select
                            title="Nereden"
                            placeholder="Nereden"
                            style={{width: "100%"}}
                            onChange={handleFromCenterChange}
                            onSearch={value => setFromCenterSearch(value)}
                            loading={fromCentersLoading}
                            allowClear
                            showSearch
                            value={fromCenter}
                            optionFilterProp="children"
                            filterOption={false}
                        >
                            {fromCenters?.result
                                ?.filter(center =>
                                    center.name
                                        .toLowerCase()
                                        .includes(fromCenterSearch.toLowerCase())
                                )
                                .map(center => (
                                    <Select.Option key={center._id} value={center._id}>
                                        {center.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            title="Nereye"
                            placeholder="Nereye"
                            style={{width: "100%"}}
                            onChange={handleToCenterChange}
                            onSearch={value => setToCenterSearch(value)}
                            loading={toCentersLoading}
                            allowClear
                            showSearch
                            value={toCenter}
                            optionFilterProp="children"
                            filterOption={false}
                        >
                            {toCenters?.result
                                ?.filter(center =>
                                    center.name.toLowerCase().includes(toCenterSearch.toLowerCase())
                                )
                                .map(center => (
                                    <Select.Option key={center._id} value={center._id}>
                                        {center.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Col>
                </div>
            </Row>
            <ActiveTransfersTable
                activeTransfers={activeTransfersData}
                activeTransfersLoading={activeTransfersLoading}
                refetchActiveTransfers={refetchActiveTransfers}
                onPageChange={handlePageChange}
            />
        </>
    );
};
